import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DocumentsService {
  public url: string;
  // public idDocumentList: string;
  // public select: string;
  // public filter: string;

  constructor(
    private http: HttpClient,
  ) {
    this.url = environment.url + 'api/documents/';
    // this.idDocumentList = environment.idDocumentsList;
    // this.select = "$select=Title,Descripcion,Documento,Imagen,TopicoId";
  }

  public getAll() {
    return this.http.get(this.url);
  }

  public getByTopic(topicId: number) {
    // this.filter = "&$filter=Topico eq " + topicId;
    return this.http.get(this.url + 'topic/' + topicId);
  }
}
